// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as coreSelectors from './selectors';
import * as coreActions from './actions';

import Confirm from '../ui/Confirm';

const styles = theme => ({
  root : {
  },
  reverseTextField : {
    color: 'white',
    '& input' : {
      color: 'white !important',
    },
    '& label' : {
      color: 'white !important',
    },
    '& fieldset' : {
      borderColor: 'white !important',
      borderWidth: 2,
    }
  },
  
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="left" ref={ref} {...props} />;
});


/*
 * User settings
 */

class Settings extends Component {
  state = {
    verifyEnableSave : false,
    verifyClearPassword : false,
    setPinOpen : false,
    settingPin : false,
    newPin : '',
  }

  enablePasswordSave = () => {
    localStorage.removeItem("neverSaveIdentity");
    this.setState({verifyEnableSave : false});
  }
  
  clearPassword = () => {
    localStorage.removeItem("userIdentityKey");
    this.setState({verifyClearPassword : false});
  }

  openSetPin = () => {
    this.setState({ setPinOpen: true, settingPin: false, newPin: ''});
  }
  
  setPin = () => {
    this.setState({ settingPin: true});
    this.props.changeAccessPin(this.state.newPin, () => {
      this.setState({ settingPin: false, setPinOpen:  false});
    }, () => {
      this.setState({ settingPin: false});
    });

  }
  
  changeNewPin = (event) => {
    let newPin = event.target.value.replace(/\D/g,'').substring(0,6);
    this.setState({ newPin });
  }
  
  render() {
    const { classes, open, onClose, user, agentUserSession } = this.props;

    let saved = typeof(localStorage.getItem("userIdentityKey")) === 'string';
    let neverSave = localStorage.getItem("neverSaveIdentity") === 'Y';

    
    
    return (
      <React.Fragment>
        <MuiCore.Dialog open={open}
                        maxWidth="sm"
                        onClose={onClose}
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle>User Settings</MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.Grid container spacing={2}>

              <MuiCore.Hidden xlDown={Boolean(user.accessPin)}>
                <MuiCore.Grid item xs={8} >
                  <MuiCore.Typography variant='body1'>
                    You do not have a PIN set.  The PIN is used when calling customer service
                    to authorize access to your account.
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={4}
                              onClick={this.openSetPin}>
                  <MuiCore.Button disabled={Boolean(agentUserSession)} fullWidth>Set PIN</MuiCore.Button>
                </MuiCore.Grid>
              </MuiCore.Hidden>
              
              {/* <MuiCore.Hidden xlDown={!Boolean(user.accessPin)}>
                <MuiCore.Grid item xs={8} >
                  <MuiCore.Typography variant='body1'>
                    Your PIN is <b>{user.accessPin}</b>.  The PIN is used when calling customer service
                    to authorize access to your account.
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={4}
                    onClick={this.openSetPin}>
                    <MuiCore.Button disabled={Boolean(agentUserSession)}
                    fullWidth>Change PIN</MuiCore.Button>
                </MuiCore.Grid>
              </MuiCore.Hidden> */}

              <MuiCore.Hidden xlDown={!saved}>
                <MuiCore.Grid item xs={8} >
                  <MuiCore.Typography variant='body1'>
                    Your password is saved on this device.
                  </MuiCore.Typography>
                </MuiCore.Grid>
                
                <MuiCore.Grid item xs={4}
                              onClick={() => this.setState({verifyClearPassword : true})}>
                    <MuiCore.Button disabled={Boolean(agentUserSession)}
                    fullWidth>Remove It</MuiCore.Button>
                </MuiCore.Grid>
              </MuiCore.Hidden>
              
              <MuiCore.Hidden xlDown={!neverSave}>              
                <MuiCore.Grid item xs={8}>
                  <MuiCore.Typography variant='body1'>
                    Password save is disabled on this device.
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={4}>
                    <MuiCore.Button fullWidth
                                    disabled={Boolean(agentUserSession)}
                                    onClick={() => this.setState({verifyEnableSave : true})}>
                    Enable It
                  </MuiCore.Button>
                </MuiCore.Grid>
              </MuiCore.Hidden>
              
              <MuiCore.Grid item xs={8}>
                <MuiCore.Typography variant='body1'>
                  Changing your password regularly will help keep your messages secure.
                </MuiCore.Typography>
              </MuiCore.Grid>
              
              <MuiCore.Grid item xs={4}>
                <MuiCore.Button
                  onClick={() => this.props.setManualPasswordChange(true)}
                  disabled={Boolean(agentUserSession)}                  
                  fullWidth>
                  Change Password
                </MuiCore.Button>
              </MuiCore.Grid>
              
              
            </MuiCore.Grid>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button onClick={onClose}>Done</MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        <Confirm open = {this.state.verifyEnableSave}
                 onCancel = {() => this.setState({verifyEnableSave : false})}
                 title = 'Enable Password Save'
                 confirmLabel = 'Enable Password Save'
                 onConfirm = {this.enablePasswordSave}
                 text = 'This will enable saving your password  the next time you login in.  Only do this on devices you trust and use regularly.'/>
        
        <Confirm open = {this.state.verifyClearPassword}
                 onCancel = {() => this.setState({verifyClearPassword : false})}
                 title = 'Remove Password'
                 confirmLabel = 'Remove Password'
                 onConfirm = {this.clearPassword}
                 text = 'This will remove your password from this device.  You will stay logged in but will need to use your password again after the session expires.  You can also remove the password by selecting logout on the menu.'/>


        <MuiCore.Dialog open={this.state.setPinOpen}
                        maxWidth="xs"
                        fullWidth
                        onClose={() => this.setState({setPinOpen : false})}
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle>Set PIN</MuiCore.DialogTitle>
          
          <MuiCore.DialogContent>
            <MuiCore.Typography variant='body1'>
              The PIN is must be 4-6 digits.
            </MuiCore.Typography>
            <MuiCore.TextField style={{marginTop: 10}}
                               value={this.state.newPin}
                               onChange={this.changeNewPin}
                               className={classes.reverseTextField}
                               fullWidth label='PIN'/>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button
              disabled={this.state.newPin.length < 4 || this.state.settingPin}
              onClick={this.setPin}>
              Set PIN
            </MuiCore.Button>
            <MuiCore.Button
              onClick={() => this.setState({setPinOpen : false})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
      </React.Fragment>      
      
    );
  }
}

Settings.propTypes = {
  open : PropTypes.bool.isRequired,
  onClose : PropTypes.func.isRequired,
}

Settings.defaultProps = {
  open : false,
}


const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    agentUserSession : coreSelectors.getAgentUserSession(state),
  });
};

const mapDispatchToProps = {
  setManualPasswordChange : coreActions.setManualPasswordChange,
  changeAccessPin : coreActions.changeAccessPin,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Settings));

